import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Select from 'react-select';
import ToggleSwitch from '@trendmicro/react-toggle-switch';

import PhoneInput from '../../FormComponents/PhoneInput';
import utils from '../../../lib/utils';
import { EmailArray, PhoneArray, filterErrors } from '../../common';

const othernotificationModes = [
  {
    label: 'Email only',
    value: ['EMAIL'],
  },
  {
    label: 'SMS only',
    value: ['SMS'],
  },
  {
    label: 'Email and SMS',
    value: ['EMAIL', 'SMS'],
  },
];

const weavenotificationModes = [
  {
    label: 'Email only',
    value: ['EMAIL'],
  },
];

export default function Notifications({
  values,
  errors,
  onChange,
  setRef,
  disabled,
  vals,
  intents,
  intentChange,
  auth,
  softwares,
  notifications,
}) {
  const notificationModes = softwares?.is_truelark ? othernotificationModes : weavenotificationModes;
  const onNotificationModeChange = (item) => {
    onChange({
      target: {
        name: 'notification_mode',
        value: item.value,
      },
    });
  };

  const onNotifyStaffSameDayChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'is_notify_staff_for_same_day_events',
        checked: !values.is_notify_staff_for_same_day_events,
      },
    });
  };

  const onIntentReportStatusChange = (id) => {
    intentChange({
      target: {
        name: 'receive_immediately',
        value: id,
      },
    });
  };

  const checkIfElementExists = (id, group) => {
    if (group.includes(id)) {
      return id;
    }
    return null;
  };
  const checkIfElementExistsinDailyReport = (id, group) => {
    if (group.includes(id)) {
      return null;
    }
    return id;
  };

  const filterBasedOnDomain = (intents) => {
    const bzsW =
      auth.booking_software && auth.booking_software !== 'undefined'
        ? auth.booking_software
        : softwares.selectedSoftware;
    const meevo_filter = ['G_BILLING_RELATED', 'G_BOOKING_CONFIRMATION'];
    let filtered_intents = intents;
    if (bzsW === 'MEEVO') {
      filtered_intents = intents.filter(
        (intent) => !meevo_filter.includes(intent.group_id),
      );
    }
    return filtered_intents;
  };

  /*
  const onAllowMBWelcomeEmailChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'allow_mindbody_welcome_email',
        checked: !values.allow_mindbody_welcome_email,
      },
    });
  };

  const onAllowMBAppointmentEmailChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'allow_mindbody_appointment_email',
        checked: !values.allow_mindbody_appointment_email,
      },
    });
  };
  */
  const onSelecChnage = (index) => {
    let current_state = [...selected];
    current_state[index] = current_state[index] === 0 ? 1 : 0;
    setSelected(current_state);
  };
  const initoptions = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  const [selected, setSelected] = useState(initoptions);
  const notification_phone =
    values.notification_phone && values.notification_phone.length > 0
      ? values.notification_phone[0]
      : '';
  const { properties } = notifications;
  return (
    <div className="notifications">
      {properties?.notification_mode && (
        <div className="notifications__row">
          <p className="notifications__row__label main-title">
            What is the best way to reach your practice when there's a need to
            follow-up with a patient?
          </p>
          <div
            className="notifications__row__input"
            ref={(c) => {
              setRef(c, 'notification_mode');
            }}
          >
            <Select
              name="notification_mode"
              value={notificationModes.filter((option) => utils.arrayEquals(option.value, values.notification_mode))}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              options={notificationModes}
              onChange={onNotificationModeChange}
              className={classnames({ 'has-error': errors.notification_mode })}
              disabled={disabled}
            />
            <span className="message--small message--error">
              {errors.notification_mode && errors.notification_mode.message}
            </span>
          </div>
        </div>
      )}
      {properties?.notification_email &&
        values.notification_mode.includes('EMAIL') ? (
          <div className="notifications__row">
            <p className="notifications__row__label pad-bottum">Email Address</p>
            <input
              type="text"
              name="notification_email"
              placeholder="Enter comma separated emails"
              value={values.notification_email}
              onChange={onChange}
              className={classnames('notifications__row__input pad-left', {
                'has-error': errors.notification_email,
              })}
              ref={setRef}
              disabled={disabled}
            />
            <span className="message--small message--error">
              {errors.notification_email && errors.notification_email.message}
            </span>
          </div>
        ) : (
          undefined
        )}
      {properties?.notification_phone &&
          values.notification_mode.includes('SMS') ? (
            <div className="notifications__row">
              <p className="notifications__row__label pad-bottum">Phone Number</p>
              <div
                className="business-phone notifications__row__input"
                ref={(c) => {
                  setRef(c, 'notification_phone');
                }}
              >
                <PhoneInput
                  placeholder="Enter phone number"
                  name="notification_phone"
                  value={notification_phone}
                  onChange={onChange}
                  className={classnames({ 'has-error': errors.notification_phone })}
                  disabled={disabled}
                />
                <span className="message--small message--error">
                  {errors.notification_phone && errors.notification_phone.message}
                </span>
              </div>
            </div>
        ) : (
          undefined
        )}
      <div className="notifications__row">
        <p className="main-title no-margin">Emergency</p>
      </div>
      {properties?.emergency_message && (
        <>
          <div className="notifications__row">
            <p className="notifications__row__label reduce-padding">
              In the event a patient states that they have an emergency,
              TrueLark responds with
            </p>
          </div>
          <div className="notifications__row">
            <div className="notifications__row__input">
              <div
                // style={{
                //   display: 'inline-block',
                //   marginTop: 10,
                //   marginBottom: 20,
                //   width: 500,
                // }}
                className="emergency-info"
              >
                I’m sorry to hear that. Unfortunately this is an automated
                system and is unable to offer any medical advice. I have
                notified the practice and they will contact you.
              </div>
            </div>
          </div>
        </>
      )}
      <div className="notifications__row">
        <p className="notifications__row__label padd-top">
          Where can the patient reach you for an emergency appointment?
        </p>
      </div>
      <div className="notifications__row padd-bottom">
        <div className="notifications__row__input">
          {properties?.public_contact_email && (
            <div className="email-array">
              <EmailArray
                value={values.publicContactEmails}
                customClassName="email-array__container"
                errors={filterErrors('publicContactEmails', errors)}
                onChange={(touched, value) => {
                  onChange({
                    target: { name: 'publicContactEmails', value, touched },
                  });
                }}
              />
              <span className="message--small message--error">
                {errors.publicContactEmails &&
                  errors.publicContactEmails.message}
              </span>
            </div>
          )}
          {properties?.public_contact_phones && (
            <div className="phone-array">
              <PhoneArray
                value={values.publicContactPhones}
                errors={filterErrors('publicContactPhones', errors)}
                customClassName="phone-array__container"
                onChange={(touched, value) => {
                  onChange({ target: { name: 'publicContactPhones', value } });
                }}
              />
              <span className="message--small message--error">
                {errors.publicContactPhones &&
                  errors.publicContactPhones.message}
              </span>
            </div>
          )}
        </div>
      </div>
      <div className="manage-notification">
        <div className="manage-notification__header">
          <div className="title">Manage your notifications</div>
          <div className="description">
            Set frequency and curate which notifications are most important for
            you.
          </div>
        </div>
        <div className="table-header">
          <div className="description">Notification Type</div>
          <div className="tab">
            Receive Immediately
          </div>
        </div>
        {filterBasedOnDomain(intents).map((option, index) => {
          return (
            <div className="table-content">
              <div className="description">{option.description}</div>
              <div className="tab">
                <ToggleSwitch
                  checked={checkIfElementExists(
                    option.group_id,
                    values.receive_immediately,
                  )}
                  value={option.group_id}
                  onChange={() => onIntentReportStatusChange(option.group_id)}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

Notifications.defaultProps = {
  onChange: () => { },
  setRef: () => { },
  values: {},
  errors: {},
  disabled: false,
};

Notifications.propTypes = {
  onChange: PropTypes.func,
  setRef: PropTypes.func,
  values: PropTypes.shape(),
  errors: PropTypes.shape(),
  disabled: PropTypes.bool,
};
